export const GET_RBDM_LIST = 'GET_RBDM_LIST';
export const GET_RBDM_FE ='GET_RBDM_FE';
export const CREATE_RBDM_FORM = 'CREATE_RBDM_FORM';
export const CREATE_JOIN_IMD = 'CREATE_JOIN_IMD';
export const UPDATE_RBDM_FORM = 'UPDATE_RBDM_FORM';
export const UPDATE_JOIN_IMD = 'UPDATE_JOIN_IMD';
export const CLEAR_ALL ='CLEAR_ALL'
export const GET_RBDM_DASHBOARD_LIST ='GET_RBDM_DASHBOARD_LIST';
